import React from 'react';
import ChartistGraph from 'react-chartist';
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Store from '@material-ui/icons/Store';
import Warning from '@material-ui/icons/Warning';
import DateRange from '@material-ui/icons/DateRange';
import LocalOffer from '@material-ui/icons/LocalOffer';
import Update from '@material-ui/icons/Update';
import Accessibility from '@material-ui/icons/Accessibility';

import Card from '../../../components/Card/Card';
import CardIcon from '../../../components/Card/CardIcon';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooter';
import Danger from '../../../components/Typography/Danger';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Table from '../../../components/Table/Table';

import {
  assetsPieChart,
  lineChart,
} from '../../../variables/charts';

import dashboardStyle from '../../../assets/jss/material-dashboard-react/views/dashboardStyle';
import Maps from '../../Views/Maps/Maps';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function PredictMaintainDashboard() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats={true} icon={true}>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p style={{ color: '#999' }}>Total Assets</p>
              <h3 style={{ color: '#000' }}>600</h3>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="ct-chart"
                data={assetsPieChart.data1}
                type="Pie"
                options={assetsPieChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <Danger>
                  <Warning />
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    status: partial failure
                  </a>
                </Danger>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats={true} icon={true}>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p style={{ color: '#999' }}>Assets Ok</p>
              <h3 style={{ color: '#000' }}>542</h3>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="ct-chart"
                data={assetsPieChart.data2}
                type="Pie"
                options={assetsPieChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <DateRange />
                  Last 24 Hours
                </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats={true} icon={true}>
              <CardIcon color="info">
                <Icon>info_outline</Icon>
              </CardIcon>
              <p style={{ color: '#999' }}>At Risk</p>
              <h3 style={{ color: '#000' }}>43</h3>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="ct-chart"
                data={assetsPieChart.data3}
                type="Pie"
                options={assetsPieChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <LocalOffer />
                  Predictive Tracking
                </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats={true} icon={true}>
              <CardIcon color="danger">
                <Accessibility />
              </CardIcon>
              <p style={{ color: '#999' }}>Asset Failure</p>
              <h3 style={{ color: '#000' }}>15</h3>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="ct-chart"
                data={assetsPieChart.data4}
                type="Pie"
                options={assetsPieChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <Update />
                  Just Updated
                </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="tabs">
          <Tab id="tab-1" aria-controls="tabpanel-1" label="Map view" />
          <Tab id="tab-2" aria-controls="tabpanel-2" label="List view" />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <div style={{ backgroundColor: "#fff" }}>
          <Maps></Maps>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <div style={{ backgroundColor: "#fff" }}>
          <Table
            tableHeaderColor="primary"
            tableHead={['No.', 'Customer', 'Location', 'Asset Type', 'Priority', 'Assigned To', 'WO Raised', 'WO Due by', 'WO Status', 'WO Type']}
            tableData={[
              ['1', 'Dakota Rice', 'Niger', 'Cooling Tower', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
              ['2', 'Minerva Hooper', 'Curaçao', 'Cooling Tower', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
              ['3', 'Sage Rodriguez', 'Netherlands', 'Cooling Tower', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'In progress', 'Electrical'],
              ['4', 'Philip Chaney', 'Korea, South', 'Cooling Tower', 'Medium', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
              ['5', 'Doris Greene', 'Malawi', 'Cooling Tower', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
              ['6', 'Mason Porter', 'Chile', 'Cooling Tower', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
              ['7', 'Sage Rodriguez', 'Netherlands', 'Cooling Tower', 'Low', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'In progress', 'Electrical'],
              ['8', 'Philip Chaney', 'Korea, South', 'Cooling Tower', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
              ['9', 'Doris Greene', 'Malawi', 'Cooling Tower', 'Low', 'Oud-Turnhout', 'Nov 12, 2020 | 17:22', 'Nov 25, 2020 | 13:22', 'Open', 'Electrical'],
              ['10', 'Mason Porter', 'Chile', 'Cooling Tower', 'Low', 'Oud-Turnhout', 'Nov 13, 2020 | 17:22', 'Nov 29, 2020 | 13:22', 'Open', 'Electrical']
            ]}
          />
        </div>
      </TabPanel>
      <div>
        <Typography variant="subtitle2" style={{ marginLeft: "32px", marginBottom: "16px" }}>ASSET STATUS CHART</Typography>
        <ChartistGraph
          className="custom-chart"
          data={lineChart.data}
          type="Line"
          options={lineChart.options}
        //listener={dailySalesChart.animation}
        />
      </div>
    </div>
  );
}

export default withStyles(dashboardStyle)(PredictMaintainDashboard);
